export default function Profile() {
	return <>Profile page</>;
}
